import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OktaContext } from '@okta/okta-react';
import { useNavigate } from '@rocketlane/rocket-router';
import { Space } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { PageLoading } from 'components/atoms/loading';
import { ProductiveHeading03, ProductiveHeading04, ProductiveHeading05 } from 'components/styles';
import { RoutePaths } from 'constant';
import { useAccountMetaQuery } from 'queries';
import { useDismissBootSkeleton } from 'utils/dismiss-boot-skeleton';
import { redirectToOAuth } from 'utils/oauth-redirect';
import { CompanyLogo } from './common';
const Container = styled.div`
  padding: var(--spacing-12);
  text-align: center;
  display: flex;
  width: 100%;
  min-width: 420px;
  min-height: 100vh;
  min-height: 100dvh;
  justify-content: center;
  align-items: center;
  background: var(--page-background, #ececec);
`;
const Heading = styled.div`
  ${ProductiveHeading04};
`;
const Strong = styled.strong`
  font-weight: var(--font-weight-bold);
  padding-left: var(--spacing-03);
`;
const Message = styled.div`
  ${ProductiveHeading03};
`;
const Greeting = styled.div`
  ${ProductiveHeading05};
`;
const StyledButton = styled.button`
  color: var(--blue-60);
  cursor: pointer;
  background-color: transparent;
  border: none;
`;
export const GoodbyePage = ()=>{
    var _data_okta, _data_okta1, _data_okta2, _data_okta3;
    useDismissBootSkeleton();
    const [timeLeft, setTimeLeft] = useState(10);
    const oktaContext = useContext(OktaContext);
    const authState = oktaContext === null || oktaContext === void 0 ? void 0 : oktaContext.authState;
    const { data, isLoading } = useAccountMetaQuery();
    const push = useNavigate();
    const isAuthenticated = authState === null || authState === void 0 ? void 0 : authState.isAuthenticated;
    useEffect(()=>{
        if (isAuthenticated) {
            push(RoutePaths.logout, {
                replace: true
            });
        }
    }, [
        isAuthenticated,
        push
    ]);
    // When cookies are enabled, skip the timer and auto-redirect
    useEffect(()=>{
        var _data_okta, _data_okta1;
        // When cookies are enabled, skip the timer and auto-redirect
        if ((data === null || data === void 0 ? void 0 : (_data_okta = data.okta) === null || _data_okta === void 0 ? void 0 : _data_okta.cookiesEnabled) === true && (data === null || data === void 0 ? void 0 : (_data_okta1 = data.okta) === null || _data_okta1 === void 0 ? void 0 : _data_okta1.clientId)) {
            return ()=>{};
        }
        const interval = setInterval(()=>{
            if (timeLeft > 0) {
                setTimeLeft(timeLeft - 1);
            } else if (timeLeft === 0) {
                var _data_okta, _data_okta1;
                clearInterval(interval);
                if ((data === null || data === void 0 ? void 0 : (_data_okta = data.okta) === null || _data_okta === void 0 ? void 0 : _data_okta.cookiesEnabled) === true && (data === null || data === void 0 ? void 0 : (_data_okta1 = data.okta) === null || _data_okta1 === void 0 ? void 0 : _data_okta1.clientId)) {
                    redirectToOAuth(data.okta.clientId);
                } else {
                    push(RoutePaths.login);
                }
            }
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        timeLeft,
        push,
        data === null || data === void 0 ? void 0 : (_data_okta = data.okta) === null || _data_okta === void 0 ? void 0 : _data_okta.cookiesEnabled,
        data === null || data === void 0 ? void 0 : (_data_okta1 = data.okta) === null || _data_okta1 === void 0 ? void 0 : _data_okta1.clientId
    ]);
    const handleReturnToLogin = ()=>{
        var _data_okta, _data_okta1;
        if ((data === null || data === void 0 ? void 0 : (_data_okta = data.okta) === null || _data_okta === void 0 ? void 0 : _data_okta.cookiesEnabled) === true && (data === null || data === void 0 ? void 0 : (_data_okta1 = data.okta) === null || _data_okta1 === void 0 ? void 0 : _data_okta1.clientId)) {
            redirectToOAuth(data.okta.clientId);
        } else {
            push(RoutePaths.login);
        }
    };
    return isLoading ? /*#__PURE__*/ _jsx(PageLoading, {}) : /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsxs(Space, {
            size: 80,
            direction: "vertical",
            children: [
                /*#__PURE__*/ _jsxs(Space, {
                    size: 48,
                    direction: "vertical",
                    children: [
                        /*#__PURE__*/ _jsxs(Space, {
                            size: 96,
                            direction: "vertical",
                            children: [
                                /*#__PURE__*/ _jsxs(Space, {
                                    size: 24,
                                    children: [
                                        data && /*#__PURE__*/ _jsx(CompanyLogo, {
                                            data: data.company
                                        }),
                                        /*#__PURE__*/ _jsxs(Heading, {
                                            children: [
                                                data === null || data === void 0 ? void 0 : data.company.companyName,
                                                /*#__PURE__*/ _jsx(Strong, {
                                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                                        id: "onboarding"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Message, {
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "goodbye.logged_out"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Greeting, {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "goodbye.great_day"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Space, {
                    direction: "vertical",
                    size: 12,
                    children: [
                        (data === null || data === void 0 ? void 0 : (_data_okta2 = data.okta) === null || _data_okta2 === void 0 ? void 0 : _data_okta2.cookiesEnabled) === true && (data === null || data === void 0 ? void 0 : (_data_okta3 = data.okta) === null || _data_okta3 === void 0 ? void 0 : _data_okta3.clientId) ? null : /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "goodbye.redirect",
                                values: {
                                    timeLeft
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(StyledButton, {
                                type: "button",
                                onClick: handleReturnToLogin,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "goodbye.return_login"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
